import { LinkContent } from "../../LinkDataInterface";
import { faGoogleDrive } from "@fortawesome/free-brands-svg-icons";
import {
  faBook,
  faInbox,
  faCompassDrafting,
  faPeopleRoof,
  faUsersRectangle,
  faVestPatches,
  faPlaneDeparture,
  faBuildingColumns,
  faHardDrive,
} from "@fortawesome/free-solid-svg-icons";

export const mail: LinkContent = {
  faLogo: faInbox,
  title: "Mail",
  link: "https://mail.polylan.ch/",
};

export const nas: LinkContent = {
  faLogo: faHardDrive,
  title: "NAS",
  link: "https://nas.polylan.ch:5001/",
};

export const wiki: LinkContent = {
  faLogo: faBook,
  title: "Wiki",
  link: "https://wiki.polylan.ch/",
};

export const trelloEvent: LinkContent = {
  faLogo: faCompassDrafting,
  title: "Trello logistique",
  link: "https://trello.polylan.ch/boards/1454578703710291301",
};

export const odjPleniaire: LinkContent = {
  faLogo: faUsersRectangle,
  title: "OdJ Pléniaire P41",
  link: "https://pv.polylan.ch/rnGjxQkRSN2RbWDBOg4b8A",
};

export const odjEven: LinkContent = {
  faLogo: faVestPatches,
  title: "OdJ Evenementiel (Empty)",
  link: "",
};

export const odjComm: LinkContent = {
  faLogo: faPlaneDeparture,
  title: "OdJ Comm (Empty)",
  link: "",
};
export const odjPresidence: LinkContent = {
  faLogo: faBuildingColumns,
  title: "OdJ Présidence P41",
  link: "https://pv.polylan.ch/k-aNVt03THGwD_o7Son-sw#",
};

export const gdrive: LinkContent = {
  faLogo: faGoogleDrive,
  title: "GoogleDrive",
  link: "https://drive.google.com/drive/folders/0Bxcz8s_btUBvYjg4MjA3MmYtOWU0Ny00M2U1LTk4ZGYtYzdhNDdmZDVjNzRi?resourcekey=0-el-mmUDASNw8u03qOVU_rQ&usp=sharing",
};

export const organigram: LinkContent = {
  faLogo: faPeopleRoof,
  title: "Organigrame",
  link: "https://docs.google.com/drawings/d/16d1re9lg9hRW-Vl563AST-WcSR_OxWscBPaKyBnjHOw/edit",
};

/* From PJ pour avoir les memes emoji)
  faLogo: faUserSecret, title: "Sécurité 2025",
  faLogo: faWalkieTalkie, title: "PC 2025",
  faLogo: faFileWaveform, title: "Document dynamique 2025",
  faLogo: faDoorOpen, title: "DocDesPortes 2025",
  faLogo: faPersonMilitaryPointing, title: "Agents devis",
  faLogo: faHouseFire, title: "Procédures d'urgence 2025",
  faLogo: faFileShield, title: "Théorie urgence 2025",
  faLogo: faCompassDrafting, title: "Besoin tech 2025",
  faLogo: faCircleInfo, title: "Fiche Générale 2025",
  faLogo: faFingerprint, title: "Fiche Agent 2025",
  faLogo: faClipboardUser, title: "Fiche Staff 2025",
  faLogo: faChampagneGlasses, title: "Suivit anim 2025",
  faLogo: faCalendar, title: "Planning par salle 2025",
  faLogo: faClock, title: "Doc des heures 2025",
  faLogo: faIdBadge, title: "Accreds",
  faLogo: faUserCheck, title: "Validateur stand",
  faLogo: faUserCheck, title: "Planning comité 2025",
  faLogo: faMap, title: "Cartographe",
  faLogo: faCodeBranch, title: "GitHub"
*/
